import routes from "../../common/routes"
import { toSlug } from '../../common/toSlug';

const getServiceRoute = (serviceName:string):string=>{
    return `${routes.Services}${toSlug(serviceName)}/`
}
export default getServiceRoute